// extracted by mini-css-extract-plugin
export default {"btn":"CancelBtn_btn__5SU3s"};